import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaInfoCircle } from 'react-icons/fa';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import {
  convertToNumber,
  debounce,
  getGenderLabel,
  isNumeric,
  onlyNotSpecialCharacters,
  verifyEmail
} from '../../../../../_helpers/_methods';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';
import PhysicalLocationDetails from '../../../../admin/Events/Steps/components/PhysicalLocationDetails';
import updateAction from './updateAction';

function IndividualStep0() {
  const intl = useIntl();
  const lang = useSelector((state) => state?.local?.local);
  const { id, edit: isEdit } = useParams();
  const { actions } = useStateMachine({ updateAction });
  const { state } = useStateMachine({ updateAction });
  const navigate = useNavigate();
  const location = useLocation();
  const [isEmailValid, setIsEmailValid] = useState(true);

  // const [isEmailInValid, setIsEmailInValid] = useState(false);
  const [isPhoneInValid, setIsPhoneInValid] = useState(false);

  const rosters = useSelector((state) => state.rosters.rosters);

  useEffect(() => {
    setValue(
      'roster_gender',
      state?.roster_gender
        ? { label: state?.roster_gender.label, value: state?.roster_gender.value }
        : ''
    );

    if (isEdit && rosters) {
      setValue('fullname', rosters.user?.fullname);
      setValue('individual_roster_phone_num', rosters.user?.phone);
      setValue('email', rosters.user?.email);
      setValue('roster_gender', {
        label: rosters.user?.gender,
        value: rosters.user?.gender
      });
      setValue('individual_roster_pan_number', rosters.pan);
    }
  }, [rosters]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    // setError,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });

  const handleRosterGender = (e) => {
    setValue('roster_gender', e);
    clearErrors('roster_gender');
  };

  const onSubmit = async (data) => {
    if (!(await validatePhone({ phone: data.individual_roster_phone_num }))) {
      return;
    }
    if (!(await validateEmail({ email: data.email }))) {
      return;
    }
    if (isEdit) {
      data.address_id = rosters.user.address[0]?.id;
    }
    actions.updateAction(data);

    let path = location.pathname.split('/');
    if (isEdit) {
      navigate(`/admin/rosters/individual/${id}/edit/1`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/individual_apply/1')
        : navigate('/rosters/individual_apply/1');
    }
  };

  const handlePhoneCheck = async (e) => {
    let body = { phone: e.target.value };
    clearErrors('individual_roster_phone_num');

    body.phone.length === 0 ? setIsPhoneInValid(false) : await validatePhone(body);
  };
  const validatePhone = async (body) => {
    try {
      if (isEdit) {
        if (rosters.user.phone !== body.phone) {
          await fetchWrapper.post('/validate-phone/', body);
          clearErrors('mobile_number');
          setIsPhoneInValid(false);
        }
        return true;
      } else {
        await fetchWrapper.post('/validate-phone/', body);
        clearErrors('mobile_number');
        setIsPhoneInValid(false);
        return true;
      }
    } catch (error) {
      setIsPhoneInValid(
        error.error[0]
          ? error.error[0]
          : lang === 'ne'
          ? error.error.non_field_error_np
          : error.error.non_field_error
      );
      return false;
    }
  };

  const handleEmailCheck = async (e) => {
    clearErrors('email');
    setIsEmailValid(false);

    let body = { email: e.target.value };
    if (body.email.lenght < 2) {
      setIsEmailValid(false);
    } else {
      if (verifyEmail(body.email)) {
        await validateEmail(body);
      } else {
        setIsEmailValid(intl.formatMessage({ id: 'email_validate_message' }));
      }
    }
  };

  const validateEmail = async (body) => {
    try {
      if (isEdit) {
        if (rosters.user?.email !== body.email) {
          await fetchWrapper.post('/validate-email/', body);
          clearErrors('email');
          setIsEmailValid(true);
        }
        return true;
      } else {
        await fetchWrapper.post('/validate-email/', body);
        clearErrors('email');
        setIsEmailValid(true);
        return true;
      }
    } catch (error) {
      setIsEmailValid(
        lang === 'ne' ? error.error?.non_field_error_np : error.error?.non_field_error
      );
      return false;
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-md-12">
          <div className="alert alert-info d-flex align-items-center">
            <FaInfoCircle size={50} className="me-3" />
            <FormattedMessage id="registration.rosterWelcome" />
          </div>
        </div>

        <div className="">
          <h5 className="col-12 mt-2">
            <FormattedMessage id="personal_details" />
          </h5>
          <div className="row">
            <div className="col-md-3 mb-2 ps-4">
              <FormattedMessage id="fullname">
                {(placeholder) => (
                  <FormGroup
                    type="text"
                    placeholder={placeholder[0]}
                    register={register}
                    error={errors}
                    onChange={(e) => {
                      e.target.value = onlyNotSpecialCharacters(e.target.value);
                    }}
                    required={true}
                    errorId={`fullname`}
                    defaultValue={state?.fullname}
                    id="fullname"
                    label={<FormattedMessage id="fullname" />}
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="col-md-2">
              <FormattedMessage id="mobile_number">
                {(placeholder) => (
                  <FormGroup
                    id="individual_roster_phone_num"
                    type="text"
                    placeholder={placeholder[0]}
                    register={register}
                    min={0}
                    max={10}
                    error={errors}
                    onChange={(e) => {
                      if (isNumeric(e.target.value)) {
                        if (e.target.value.length === 0 || 1 > e.target.value.length < 10)
                          debounce(handlePhoneCheck, 1000)(e);
                      } else {
                        e.target.value = convertToNumber(e.target.value);
                        if (e.target.value.length === 0 || 1 > e.target.value.length < 10)
                          debounce(handlePhoneCheck, 1000)(e);
                      }
                    }}
                    errorId={`mobile_number`}
                    required={true}
                    defaultValue={state?.individual_roster_phone_num}
                    label={<FormattedMessage id="mobile_number" />}
                  />
                )}
              </FormattedMessage>

              {errors.mobile_number ? (
                ''
              ) : isPhoneInValid ? (
                <div className="ms-2">
                  <small className="text-danger">{isPhoneInValid}</small>
                </div>
              ) : null}
            </div>
            <div className="col-md-3">
              <FormattedMessage id="email_placeholder">
                {(placeholder) => (
                  <FormGroup
                    id="email"
                    type="email"
                    placeholder={placeholder[0]}
                    error={errors}
                    errorId={`email`}
                    register={register}
                    onChange={(e) => {
                      if (e.target.value.length === 0) {
                        setIsEmailValid(false);
                      } else {
                        debounce(handleEmailCheck, 1000)(e);
                      }
                    }}
                    defaultValue={state?.email}
                    required={true}
                    label={<FormattedMessage id="email" />}
                  />
                )}
              </FormattedMessage>
              {isEmailValid ? (
                <div className="ms-2">
                  <small className="text-danger">{isEmailValid}</small>
                </div>
              ) : null}
            </div>

            <div className="col-md-2 ">
              <FormattedMessage id="select_gender">
                {(placeholder) => (
                  <FormGroup
                    id="roster_gender"
                    type="select"
                    placeholder={placeholder[0]}
                    register={register}
                    error={errors}
                    errorId={`gender`}
                    required={true}
                    onChange={handleRosterGender}
                    options={[
                      {
                        label: lang === 'ne' ? 'पुरुष' : 'Male',
                        value: 'male'
                      },
                      {
                        label: lang === 'ne' ? 'महिला' : 'Female',
                        value: 'female'
                      },
                      {
                        label: lang === 'ne' ? 'यौनिक तथा लैङ्गिक अल्पसंख्यक' : 'Other',
                        value: 'other'
                      }
                    ]}
                    defaultValue={
                      state?.roster_gender ||
                      (isEdit && {
                        label: getGenderLabel(rosters.user?.gender, lang),
                        value: rosters.user?.gender
                      })
                    }
                    label={<FormattedMessage id="gender" />}
                  />
                )}
              </FormattedMessage>
            </div>

            <div className="col-md-2">
              <FormattedMessage id="pan_number">
                {(placeholder) => (
                  <FormGroup
                    id="individual_roster_pan_number"
                    type="number"
                    min={0}
                    placeholder={placeholder[0]}
                    register={register}
                    error={errors}
                    required={false}
                    errorId={`pan_number`}
                    defaultValue={state?.individual_roster_pan_number}
                    label={<FormattedMessage id="pan_number" />}
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="row">
              <h5 className="col-12 mt-2">
                <FormattedMessage id="permanent_address" />
              </h5>

              <div className="col-12 px-4">
                <PhysicalLocationDetails
                  isEdit={isEdit}
                  id="rosters_address"
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <hr />
          <NavigationButtonGroup
            hasPrevious={false}
            backTo={isEdit ? '/admin/rosters/individual_list' : ''}
            // showSubmit={id}
          />
        </div>
      </div>
    </form>
  );
}

export default IndividualStep0;
